/** @format */

import {Routes, Route} from 'react-router-dom';

import {ROUTES} from 'constants/ROUTES';

import PrivateRoute from 'components/PrivateRoute';

import BaseLayout from 'layouts/BaseLayout';

import AccessDenied from './AccessDenied';

const Errors = () => {
  return (
    <BaseLayout>
      <Routes>
        <Route
          path={ROUTES.ASSESS_DENIED}
          element={
            <PrivateRoute>
              <AccessDenied />
            </PrivateRoute>
          }
        />
      </Routes>
    </BaseLayout>
  );
};

export default Errors;
